import React, { Component } from 'react';
import { DIMENSIONS } from 'services/layoutManager';
import BloxPage from 'sub_components/Layout/BloxPage';
import ComponentWrapper from 'sub_components/Layout/ComponentWrapper';
import { RESOLUTIONS } from 'services/config';
import { MENU as COLO_MENU } from 'utils/ColoConstants';
import { SITE_PAGES, SITE_MODULES } from 'utils/CommonConstants';
import { Utils } from 'services/utils';

const LAYOUT_CONFIG = {
	[RESOLUTIONS.LOW]: {
		power: { x: 1, y: 24, dim: DIMENSIONS.FOUR_BY_TEN },
		trends: { x: 1, y: 62, dim: DIMENSIONS.FOUR_BY_TEN },
		topRight: { x: 5, y: 1, dim: DIMENSIONS.TWO_BY_SIX },
		topLeft: { x: 1, y: 1, dim: DIMENSIONS.TWO_BY_FOUR },
	},
	[RESOLUTIONS.MED]: {
		power: { x: 1, y: 34, dim: DIMENSIONS.FOUR_BY_TEN },
		trends: { x: 1, y: 95, dim: DIMENSIONS.FOUR_BY_TEN },
		topRight: { x: 5, y: 1, dim: DIMENSIONS.TWO_BY_SIX },
		topLeft: { x: 1, y: 1, dim: DIMENSIONS.TWO_BY_FOUR },
	},
	[RESOLUTIONS.HIGH]: {
		power: { x: 1, y: 54, dim: DIMENSIONS.FOUR_BY_TEN },
		trends: { x: 1, y: 146, dim: DIMENSIONS.FOUR_BY_TEN },
		topRight: { x: 5, y: 1, dim: DIMENSIONS.TWO_BY_SIX },
		topLeft: { x: 1, y: 1, dim: DIMENSIONS.TWO_BY_FOUR },
	},
};

class PowerDetailPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			role: null,
		};
	}

	componentWillUnmount() {
		Utils.removeHorizontalBar();
	}

	componentDidMount() {
		const { updateModule, updatePage, addPageToBreadCrumbs, site, permissions } = this.props;
		const mainContent = document.getElementById('main-content');
		updatePage(SITE_PAGES.COLO[COLO_MENU.POWER]);
		addPageToBreadCrumbs(SITE_PAGES.COLO[COLO_MENU.POWER], SITE_MODULES.COLO);
		if (site?.module !== 'COLO' || !permissions?.permissions) {
			this.getModulePages();
		}
		updateModule(SITE_MODULES.COLO);
		this.getModulePages();
		console.log('main content ', mainContent);
		if (mainContent) {
			mainContent.classList.add('no-padding');
		}
	}

	render() {
		const {
			breakpoint,
			location,

			permissions: pages,
		} = this.props || {};

		return (
			<BloxPage
				name='page colocation'
				layout={LAYOUT_CONFIG[breakpoint]}
				breakpoint={breakpoint}
				location={location}
			>
				<div key={`topRight`} className='topRight'>
					<ComponentWrapper hideBorder hideTitle>
						Power Detail
					</ComponentWrapper>
				</div>
				<div key={`topLeft`} className='topLeft'>
					<ComponentWrapper hideBorder hideTitle></ComponentWrapper>
				</div>

				<div key={`power`} className='power'>
					{pages && <ComponentWrapper title='Current Power' hideBorder></ComponentWrapper>}
				</div>
				<div key={`trends`} className='trends'>
					<ComponentWrapper title='Power Trends' hideBorder></ComponentWrapper>
				</div>
			</BloxPage>
		);
	}
}

export default PowerDetailPage;
